import axios from 'axios'
// import wsService from '@/services/websocket';
// import ENV from '@/environment.js';

// const URL_WSS = process.env.NODE_ENV == "development" ? ENV.WS_DEV : ENV.API

export default {
    namespaced: true,
    state: {
        token: null,
        user: null,
        cor: [],
        sectores: [],
        noticeDanger: false,
        noticeSinAlimentacion: false,
        noticesDangers: {
            selectNoticeDanger: null,
            selectedsNoticesDangers: [],
            isUpdateTable: false,
            isShowModalOT: false,
        },
        wsStatus: 'disconnected', // 'disconnected' | 'connecting' | 'connected' | 'error'
    },
    getters: {
        getToken(state) {
            return state.token
        },
        getCor(state) {
            return state.cor
        },
        getSectores(state) {
            return state.sectores
        },
        authenticated(state) {
            return state.token && state.user;
        },
        user(state) {
            return state.user
        },
        getNoticeDanger(state){
            return state.noticeDanger;
        },
        getNoticeSinAlimentacion(state){
            return state.noticeSinAlimentacion;
        },
        getNoticesDangers(state){
            return state.noticesDangers;
        },
        wsStatus(state){
            return state.wsStatus;
        },
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_USER(state, data) {
            state.user = data
        },
        SET_DEPARTMENT(state, data) {
            state.cor = data
        },
        SET_SECTORS(state, data) {
            state.sectores = data
        },
        SET_NOTICE_DANGER(state, data){
            state.noticeDanger = data;
        },
        SET_NOTICE_SIN_ALIMENTACION(state, data){
            state.noticeSinAlimentacion = data;
        },
        SET_NOTICES_DANGERS(state, data){
            state.noticesDangers = data;
        },
        SET_WS_STATUS(state, status) {
            state.wsStatus = status;
        },

    },
    actions: {

        async signIn({ dispatch }, credentials) {
            const response = await axios.post('/auth/login', credentials)
            return dispatch('attempt', response.data.access_token)
        },

        async attempt({ commit, state, dispatch }, token) {
            if (token) {
                commit('SET_TOKEN', token)
            }
            if (!state.token) {
                return
            }
            try {
                let response = await axios.post('auth/user-profile')
                const [role] = response.data.roles
                if (role) {
                    response.data.roles = role
                    response.data.permissions = role.permissions
                }
                commit('SET_USER', response.data);
                await dispatch('connectWebSocket');
            } catch (e) {
                commit('SET_USER', null)
                commit('SET_TOKEN', null)
            }
        },
        async signOut({ commit }) {
            return axios.post('auth/logout')
                .then(() => {
                    commit('SET_USER', null)
                    commit('SET_TOKEN', null)
                    commit('wsStatus', 'disconnected')
                })
        },
        setSectors({ commit }, data) {
            commit('SET_SECTORS', data)
        },
        zoneWork: ({ commit, state }, data) => {
            if (data) {
                commit('SET_DEPARTMENT', data)
                commit('SET_SECTORS', data)
            }
            if (!state.cor) {
                return
            }
        },
        refreshToken: ({ commit }) => {
            return new Promise((resolve, reject) => {
                axios
                    .post(`auth/refresh`)
                    .then(res => {
                        if (res.data.access_token) {
                            resolve(res);
                            commit('SET_TOKEN', res.data.access_token)
                            axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.access_token}`
                            sessionStorage.setItem('token', res.data.access_token)
                            // console.log("∑Token", res.data.access_token);
                            // console.table(res.data);
                        }
                    })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        setNoticeDanger({ commit }, data){
            commit("SET_NOTICE_DANGER", data);
        },
        setNoticeSinAlimentacion({ commit }, data){
            commit("SET_NOTICE_SIN_ALIMENTACION", data);
        },
        setNoticesDangers({ commit }, data){
            commit("SET_NOTICES_DANGERS", data);
        },
        async connectWebSocket({ state }) {
            if (!state.token) return;

            // commit('SET_WS_STATUS', 'connecting');
            // try {
            //     await wsService.connect(URL_WSS, state.token);
            //     commit('SET_WS_STATUS', 'connected');
            // } catch (err) {
            //     commit('SET_WS_STATUS', 'error');
            //     console.error('Error conectando WebSocket:', err);
            // }
        },
    }
}